import { getDirectives, MapperKind, mapSchema } from '@graphql-tools/utils';
import { cloneSubschemaConfig } from '@graphql-tools/delegate';
export function computedDirectiveTransformer(computedDirectiveName) {
    return (subschemaConfig) => {
        const newSubschemaConfig = cloneSubschemaConfig(subschemaConfig);
        mapSchema(subschemaConfig.schema, {
            [MapperKind.OBJECT_FIELD]: (fieldConfig, fieldName, typeName, schema) => {
                var _a, _b, _c, _d;
                const mergeTypeConfig = (_a = newSubschemaConfig.merge) === null || _a === void 0 ? void 0 : _a[typeName];
                if (mergeTypeConfig == null) {
                    return undefined;
                }
                const computed = getDirectives(schema, fieldConfig)[computedDirectiveName];
                if (computed == null) {
                    return undefined;
                }
                const selectionSet = computed.fields != null ? `{ ${computed.fields} }` : computed.selectionSet;
                if (selectionSet == null) {
                    return undefined;
                }
                mergeTypeConfig.fields = (_b = mergeTypeConfig.fields) !== null && _b !== void 0 ? _b : {};
                mergeTypeConfig.fields[fieldName] = (_c = mergeTypeConfig.fields[fieldName]) !== null && _c !== void 0 ? _c : {};
                const mergeFieldConfig = mergeTypeConfig.fields[fieldName];
                mergeFieldConfig.selectionSet = (_d = mergeFieldConfig.selectionSet) !== null && _d !== void 0 ? _d : selectionSet;
                mergeFieldConfig.computed = true;
                return undefined;
            },
        });
        return newSubschemaConfig;
    };
}
//# sourceMappingURL=computedDirectiveTransformer.js.map